import { createSlice } from "@reduxjs/toolkit";
import { loginApi, logoutApi, userApi } from "../services/auth.service";

const initialState = {
  loginLoader: false,
  loginRes: null,
  successMsg: "",
  errorMsg: "",
  userData: null,
};
const LoginSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    ResetValuesLogin: (state, action) => {
      state.loginRes = null;
      state.errorMsg = "";
      state.successMsg = "";
      state.loginLoader = false;
      state.userData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginApi.pending, (state, action) => {
        state.loginLoader = true;
      })
      .addCase(loginApi.fulfilled, (state, action: any) => {
        if (action && action.payload && action.payload?.data) {
          state.loginRes = action.payload?.data;
          state.loginLoader = false;
          state.successMsg = action.payload.message;
        } else {
          state.errorMsg = "Invalid Login";
          state.loginLoader = false;
        }
      })
      .addCase(loginApi.rejected, (state, action) => {
        state.loginLoader = false;
        state.errorMsg = action.error.message
          ? action.error.message
          : "Login Error";
      })
      .addCase(logoutApi.rejected, (state, action) => {
        state.errorMsg = action.error.message
          ? action.error.message
          : "Logout Error";
      })
      .addCase(userApi.fulfilled, (state, action: any) => {
        if (action.payload && action.payload?.data) {
          state.userData = action.payload?.data;
          state.loginLoader = false;
          state.successMsg = action.payload.message;
        } else {
          state.errorMsg = "User Api Error";
          state.loginLoader = false;
        }
      })
      .addCase(userApi.rejected, (state, action) => {
        state.errorMsg = action.error.message
          ? action.error.message
          : "User Api Error";
      });
  },
});

export const { ResetValuesLogin } = LoginSlice.actions;
export default LoginSlice.reducer;